import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useBreadcrumb } from "@website/ui/breadcrumb/breadcrumb.hook";
import styles from "@website/ui/breadcrumb/breadcrumb.module.scss";
import { BreadcrumbPropertiesType } from "@website/ui/breadcrumb/breadcrumb.types";
import { Link } from "@website/ui/link";
import { getChannel } from "@website/utils/channel/get-channel";
import omit from "lodash-es/omit";
import { FC, Fragment } from "react";
export const Breadcrumb: FC<BreadcrumbPropertiesType> = properties => {
  const $ = _c(8);
  const {
    className,
    list,
    variant
  } = properties;
  const {
    rootProperties,
    itemsProperties
  } = useBreadcrumb(properties);
  const t0 = `${styles.breadcrumb} ${className ?? ""}`;
  let t1;
  if ($[0] !== itemsProperties || $[1] !== list || $[2] !== variant) {
    t1 = variant === "collapsed" && list.length > 3 ? <li itemProp="itemListElement" itemScope={true} itemType="https://schema.org/ListItem">{getChannel() === "snapp-ir" ? <a href="/" {...omit(itemsProperties[0], ["href", "onClick"])}>{list[0].title}</a> : <Link {...itemsProperties[0]}>{list[0].title}</Link>}<div className={styles.divider}>/</div><MaterialIcon className={styles["more-icon"]} name="more_horiz" variant="outlined" /><div className={styles.divider}>/</div><Link {...itemsProperties[list.length - 2]}>{list.at(-2)?.title}</Link><div className={styles.divider}>/</div><Link {...itemsProperties[list.length - 1]}>{list.at(-1)?.title}</Link></li> : list.map((item, index) => <Fragment key={item.title}>{index > 0 ? <li className={styles.divider}>/</li> : null}<li itemProp="itemListElement" itemScope={true} itemType="https://schema.org/ListItem">{index === 0 && getChannel() === "snapp-ir" ? <a href="/" {...omit(itemsProperties[index], ["href", "onClick"])} data-testid={itemsProperties[index].disabled ? "breadcrumb_item_active" : "breadcrumb_item"}>{item.title}</a> : <Link {...itemsProperties[index]} data-testid={itemsProperties[index].disabled ? "breadcrumb_item_active" : "breadcrumb_item"}>{item.title}</Link>}<meta content={`${index + 1}`} itemProp="position" /></li></Fragment>);
    $[0] = itemsProperties;
    $[1] = list;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== rootProperties || $[5] !== t0 || $[6] !== t1) {
    t2 = <nav><ol {...rootProperties} className={t0} itemScope={true} itemType="https://schema.org/BreadcrumbList">{t1}</ol></nav>;
    $[4] = rootProperties;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};